import type {CaseContext, IssueCoding, RelevanceCriteria} from '../../../../../redux/slice/aiReviewSliceV2';
import type {IssueCode} from '../../../../../api/types/aiReview.type';

export const toJobDetailsDisplayText = (value: unknown): string => {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value !== 'object') {
    return '';
  }

  const record = value as Partial<CaseContext> & Partial<RelevanceCriteria>;
  if (typeof record.executive_summary === 'string' && record.executive_summary) {
    return record.executive_summary;
  }
  if (
    typeof record.master_relevance_standard === 'string' &&
    record.master_relevance_standard
  ) {
    return record.master_relevance_standard;
  }
  return '';
};

export const toJobDetailsIssueCodeLines = (
  issueCodes: unknown
): Array<{code: string; question: string}> => {
  if (Array.isArray(issueCodes)) {
    return (issueCodes as IssueCode[]).map((item) => ({
      code: item.code ?? '',
      question: item.question ?? '',
    }));
  }

  const coding = issueCodes as Partial<IssueCoding> | null | undefined;
  if (!coding?.issue_codes?.length) {
    return [];
  }

  return coding.issue_codes.map((item) => ({
    code: item.code_name ?? '',
    question: item.definition ?? '',
  }));
};
